import { Country } from './locales';

const currencies = {
  [Country.SE]: 'kr',
  [Country.FI]: 'EUR',
};

export function useCurrency(country = Country.SE) {
  return currencies[country];
}
